import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { insights } from "../content/insights";
import { useLocale, useLocalePath, useT } from "../i18n/useT";

export default function InsightsIndex() {
  const t = useT();
  const localePath = useLocalePath();
  const locale = useLocale();
  const dateFmt = locale === "es" ? "es-ES" : "en-GB";
  return (
    <div className="min-h-screen bg-ink-950 text-ink-100">
      <Header />
      <main className="container-page py-16 sm:py-24">
        <Link
          to={localePath("/")}
          className="inline-flex items-center gap-1.5 text-sm text-ink-400 hover:text-ink-100"
        >
          <ArrowLeft className="size-4" />
          {t.insightsIndex.backHome}
        </Link>

        <header className="mt-8 max-w-2xl">
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-ink-50">
            {t.insightsIndex.h1}
          </h1>
          <p className="mt-3 text-base text-ink-300 leading-relaxed">
            {t.insightsIndex.description}
          </p>
        </header>

        <ul className="mt-12 divide-y divide-ink-800/80 border-y border-ink-800/80">
          {insights.map((p) => (
            <li key={p.slug} className="py-8">
              <Link to={localePath(`/insights/${p.slug}`)} className="group block">
                <div className="flex flex-wrap items-center gap-3 text-xs text-ink-400">
                  <span className="font-mono uppercase tracking-wider text-accent-500">
                    {p.category}
                  </span>
                  <span>·</span>
                  <time dateTime={p.publishedAt}>
                    {new Date(p.publishedAt).toLocaleDateString(dateFmt, {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </time>
                  <span>·</span>
                  <span>
                    {p.readMinutes} {t.insightsIndex.minRead}
                  </span>
                </div>
                <h2 className="mt-3 text-xl sm:text-2xl font-semibold text-ink-50 group-hover:text-accent-400 transition">
                  {p.title}
                </h2>
                <p className="mt-2 text-sm text-ink-300 leading-relaxed max-w-3xl">
                  {p.excerpt}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <Footer />
    </div>
  );
}
